module.exports = __webpack_public_path__ + "img/web.a8b65f8d.svg";